import {createAction, props} from '@ngrx/store';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const deleteOrganization = createAction(
  '[DeleteOrganization] Delete Organization',
  props<{ id: number }>()
);

export const deleteOrganizationSuccess = createAction(
  '[DeleteOrganization] Delete Organization Success',
  props<{ data: Organization }>()
);

export const deleteOrganizationFailure = createAction(
  '[DeleteOrganization] Delete Organization Failure',
  props<{ error: unknown }>()
);

export const clearDeleteOrganizationState = createAction(
  '[DeleteOrganization] Clear Delete Organization State'
);
